import { mixins, styled } from '@bob/library'

export const Wrapper = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 46px;
  ${mixins.media.min.tablet} {
    height: 55px;
  }
`
